import React from 'react';
import classNames from 'classnames';

import css from './ListingItem.module.css';

const ListingItem = props => {
  const {
    className,
    unavailableClassName,
    listing,
    availableText,
    unavailableText,
    ...rest
  } = props;
  const isAvailable = listing.isAvailable;
  const image = listing.images?.[0]?.attributes?.variants?.default?.url || '';
  const title = listing.attributes.title;

  const availabilityText = isAvailable ? availableText : unavailableText;

  const classes = classNames(
    css.root,
    className,
    unavailableClassName || { [css.unavailable]: !isAvailable }
  );
  const availabilityClasses = classNames(css.availabilityText, {
    [css.unavailableText]: !isAvailable,
  });

  return (
    <div className={classes} {...rest}>
      {image ? <img src={image} alt={title} className={css.listingImage} /> : null}
      <div className={css.info}>
        <span className={css.title}>{title}</span>
        <span className={availabilityClasses}>{availabilityText}</span>
      </div>
    </div>
  );
};

export default ListingItem;
